<template>
	<inertia-head title="Community" />
	<ContentSlot ref="contentSlot" :errors="errors" :flash="flash"/>
	<div class="content">

		<div class="row g-xxl-5 items-push">
			<div class="col-lg-8">
				<div class="block block-rounded mb-0">
					<div class="block-content block-content-full">
						<div v-for="(post,pIndex) in postsData">
							<div class="block block-rounded bg-transparent ribbon mb-1">
								<div class="border border-1 border-light-secondary mb-1 "></div>
								<span v-if="post.community_status!='Public'" class="ribbon-box">
									<button v-if="[null,'Requesting'].includes(post.join_status)" @click="joinCommunity(post.community_uuid,post.community_name,post.community_status)" :disabled="formJoinCommunity.processing && formJoinCommunity.community_uuid==post.community_uuid" type="button" class="btn btn-xs ms-auto rounded-pill px-2"
										:class="{'btn-alt-warning':post.join_status=='Requesting','btn-alt-info':post.join_status==null}"
									>
										<div
											v-if="formJoinCommunity.processing && formJoinCommunity.community_uuid==post.community_uuid"
											class="spinner-border spinner-border-sm text-dark me-1"
											role="status"
										>
											<span class="sr-only">Loading...</span>
										</div>
										{{post.join_status==null ? 'Join' : post.join_status}}
									</button>
								</span>
								<div class="block block-rounded bg-transparent ribbon ribbon-left ribbon-bottom mb-1">
									<inertia-link :href="'/member/community/c/'+post.community_name+'/post/'+post.post_uuid+'/'+post.slug_name" class="block block-rounded block-link-shadow mb-1">
										<div class="block-header">
											<div class="block-title">
													<div class="mb-0">
														<span class="nav-main-horizontal">
															<span class="nav-main-item">
																<img
																	class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb"
																	:src="post.icon_logo"
																/>
															</span>
															<span class="nav-main-item">
																<span class="nav-main-horizontal nav-main-hover">
																	<span class="nav-main-item">
																		<inertia-link data-bs-toggle="submenu" aria-haspopup="true" aria-expanded="false" :href="'/member/community/c/'+post.community_name" class="standard-link fw-semibold text-info fs-sm">c/{{post.community_name}}</inertia-link> 
																		<div class="nav-main-submenu bg-white block block-rounded shadow">
																			<div class="block-header p-0 px-3 pt-2">
																				<div class="block-title">
																					<p class="fw-bold m-0">{{post.community_name}}</p>
																				</div>
																			</div>
																			<div class="block-content p-3 pt-0">
																				<div class="dropdown-divider"></div>
																				<div class="row fs-xs">
																					<div class="col">
																						<div>{{post.member_total}}</div>
																						<span>Member</span>	
																					</div>
																					<div class="col">
																						<div>{{post.visit_total}}</div>
																						<span>Views</span>
																					</div>
																				</div>
																			</div>
																		</div>
																	</span>
																</span>
															</span>
															<span class="nav-main-item">
																<span class="fs-xs text-muted ms-2">{{post.posted_at}}</span>
															</span>
														</span>
													</div>
											</div>
										</div>
										<div class="block-content block-content-full pt-0">
											<div class="fw-semibold h5 mb-0">{{post.title}}</div>
							                <div class="fs-sm mt-4 pb-5" style="white-space: pre; white-space:break-spaces;" v-html="post.description"></div>
										</div>
									</inertia-link>
									<div class="ribbon-box ps-4">
						            	<span class="me-3">
						            		<button @click="votePost(post.community_name,post.post_uuid,'like',post.vote,pIndex)" :disabled="formVotePost.processing && formVotePost.post_uuid==post.post_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':post.vote==1}">
						            			<div
													v-if="formVotePost.processing && formVotePost.post_uuid==post.post_uuid & formVotePost.vote_label=='like'"
													class="spinner-border spinner-border-sm text-warning"
													role="status"
												>
													<span class="sr-only">Loading...</span>
												</div>
						            			<i v-else class="fa fa-arrow-up"></i>
						            		</button>
						            		<span class="px-1">{{post.vote_total}}</span>
						            		<button @click="votePost(post.community_name,post.post_uuid,'dislike',post.vote,pIndex)" :disabled="formVotePost.processing && formVotePost.post_uuid==post.post_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':post.vote==-1}">
						            			<div
													v-if="formVotePost.processing && formVotePost.post_uuid==post.post_uuid & formVotePost.vote_label=='dislike'"
													class="spinner-border spinner-border-sm text-danger"
													role="status"
												>
													<span class="sr-only">Loading...</span>
												</div>
						            			<i v-else class="fa fa-arrow-down"></i>
						            		</button>	
						            	</span>
						            	<inertia-link :href="'/member/community/c/'+post.community_name+'/post/'+post.post_uuid+'/'+post.slug_name" class="btn rounded-pill btn-sm btn-alt-secondary" :class="{'active':post.vote==-1}"><i class="fa fa-comment me-1"></i>{{post.comment_total}}</inertia-link>
						            </div>
								</div>
							</div>
						</div>
						<div v-if="postsData.length<=0" class="text-center">
							<h1 class="display-6 fw-bold text-info">
						        <i class="fa fa-flag me-1 opacity-50"></i>
						        <span>Community Post</span>
					     	</h1>
					      	<h3 class="fw-bold mt-5 mb-2">There Are No Community Posts Yet...</h3>
					      	<h4 class="fw-medium text-muted mb-0">Be the first to share your thoughts, ideas, or experiences. Start a discussion and connect with others in the community....</h4>
						</div>
					</div>
				</div>
				<div v-if="posts.length>4 && (is_lazy_loading || posts.length==postsData.length)" class="my-3 text-center">
					<span v-if="is_lazy_loading" class="text-info">
						<div
							class="spinner-border spinner-border-sm text-info"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						Loading more...
					</span>
					<div v-else>
						<div
							v-if="is_reloading"
							class="spinner-border spinner-border-lg text-info"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<button v-else @click="reloadPage()" type="button" class="btn btn-xs btn-outline-info">
							<i class="fa fa-refresh me-1"></i>
							Reload the page
						</button>
					</div>
				</div>	
			</div>

			<div class="col-lg-4 mb-6 relative d-none d-sm-table-cell">
				<div v-if="visited.length>0" class="block block-rounded recent-post-visit-top-fix mb-1">
					<div class="block-header pb-0">
						<div class="block-title"> RECENT POSTS VISIT</div>
					</div>
					<div class="block-content-full text-muted">
						<div v-for="(visit,vIndex) in visited" class="block block-rounded mb-1">
							<div class="dropdown-divider"></div>
							<div class="block-header pt-0">
								<div class="block-title">
									<inertia-link v-if="visit.community_name!=null" :href="route('member.community.community-home',{community_name:visit.community_name})" class="standard-link text-black-75 fs-xs">
										c/{{visit.community_name}}
									</inertia-link>
									<inertia-link v-if="visit.member_name!=null" :href="route('member.community.member-home',{member_name:visit.member_name})" class="standard-link text-black-75 fs-xs">
										m/{{visit.member_name}}
									</inertia-link>
									. <span class="fs-xs text-muted">{{visit.posted_at}}</span>
								</div>
							</div>
							<div class="block-content block-content-full pt-0 pb-1">
								<p class="m-0 fw-semibold fs-xs">
									<inertia-link v-if="visit.community_name!=null" :href="route('member.community.post-comments-home',{community_name:visit.community_name, post_uuid:visit.post_uuid, slug_name:visit.slug_name})" class="standard-link text-black-75">{{visit.title}}</inertia-link>
									<inertia-link v-if="visit.member_name!=null" :href="route('member.community.member-post-comments-home',{member_name:visit.member_name, post_uuid:visit.post_uuid, slug_name:visit.slug_name})" class="standard-link text-black-75">{{visit.title}}</inertia-link>
								</p>
								<div class="mt-3 fs-xs">
									<span class="me-3">{{visit.vote_total}} upvotes</span>
									<span>{{visit.comment_total}} comments</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>

</template>

<script>
import { debounce } from 'lodash';
import { watch, onMounted, ref, reactive } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import ContentSlot from './ContentSlot';
import { createToaster } from '@meforma/vue-toaster';
import { useForm, usePage } from '@inertiajs/inertia-vue3';

export default {
	props:{
		flash 		: Object,
		errors 		: Object,
		posts 		: Object,
		visited 	: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const is_lazy_loading 	= ref(false);
		const is_reloading 		= ref(false);

		var postsData = (props.posts ? props.posts.slice(0,4) : []);

		const contentSlot = ref(null);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}

			window.addEventListener(
				'scroll',
				debounce((e) => {
					let body_height = document.body.clientHeight;
            		let end_height = window.scrollY + window.innerHeight;

					if (
						document.body.scrollTop > 20 ||
						document.documentElement.scrollTop > 20
					) {
						// document.getElementById('scroll_top').classList.remove('d-none')
					} else {
						// document.getElementById('scroll_top').classList.add('d-none')
					}

					if(body_height == end_height)
					{
						if(is_lazy_loading.value == false)
						{
							lazyLoad();
						}
					}

				}, 100)
			)
			
		})

		const formJoinCommunity = useForm({
			community_uuid 		: null,
			community_name 		: null,
			community_status 	: null,
			processing  		: false
		});

		const formVotePost = useForm({
			post_uuid 	: null,
			vote_label  : '',
			prev_vote  	: 0,
			vote  		: 0,
			processing 	: false,
		});

		const formReloadPage = useForm({
			reload: true
		});

		const reloadPage = ()=>{
			is_reloading.value = true;
			formReloadPage.post(route('member.community.home-reload'), {
								preserveState: false,
								preserveScroll: false,
								only: ['flash','errors','posts'],
								onSuccess:()=>{
									let new_posts 		= null;

									postsData 			= [];

									is_reloading.value 	= false;

									new_posts 			= (props.posts ? props.posts.slice(0,4) : []);

									postsData.push(new_posts);
									
								},
								onError:()=>{
									is_reloading.value 		= false;
								}
							})

		}

		const lazyLoad = ()=>{
			
			let end_extract = postsData.length + 3;
			let new_posts = props.posts.slice(postsData.length,end_extract);
			
			if(props.posts.length > postsData.length)
			{
				is_lazy_loading.value = true;

				for (var i = 0; i < new_posts.length; i++) {
					postsData.push(new_posts[i]);
				}

				setTimeout(function(){
					is_lazy_loading.value = false;
				},1000);
			}
		}

		const joinCommunity = (_uuid,_name,_status)=>{
			
			formJoinCommunity.community_uuid 	= _uuid;
			formJoinCommunity.community_name 	= _name;
			formJoinCommunity.community_status 	= _status;
			formJoinCommunity.processing 		= true;

			contentSlot.value.joinCommunity(formJoinCommunity,(res)=>{
				if(res)
				{
					formJoinCommunity.reset();
				}
			});
		}


		const votePost = (_com_name,_post_uuid,_vote_label,_val,_index)=>{

			formVotePost.post_uuid 			= _post_uuid;
			formVotePost.vote_label 		= _vote_label;
			formVotePost.processing 		= true;

			contentSlot.value.votePost(null,_com_name,_post_uuid,_vote_label,_val,_index,'home_posts',(res)=>{
				if(res)
				{
					postsData[_index].vote 			= props.flash.toast.data.vote;
					postsData[_index].vote_total 	= props.flash.toast.data.vote_total;
					postsData[_index].vote_weight 	= props.flash.toast.data.vote_weight;
				}
				formVotePost.reset();
			});

		}

		// const votePost = (_com_name,_post_uuid,_vote_label,_val,_index)=>{
			
		// 	formVotePost.post_uuid 			= _post_uuid;
		// 	formVotePost.vote_label 		= _vote_label;
		// 	formVotePost.prev_vote 			= _val;
			
		// 	if(_vote_label=='like')
		// 	{
		// 		formVotePost.vote 		= 1;
		// 	}else{
		// 		formVotePost.vote 		= -1;
		// 	}
			
		// 	if((_val==1 && _vote_label=='like') || (_val==-1 && _vote_label=='dislike'))
		// 	{
		// 		formVotePost.vote 		= 0;
		// 	}

		// 	formVotePost.post(route('member.community.post-vote',{community_name:_com_name,post_uuid:_post_uuid}), {
		// 							preserveState: true,
		// 							preserveScroll: true,
		// 							only: ['flash','errors'],
		// 							onSuccess:()=>{
		// 								let flash = props.flash.toast;
		// 								if(flash.type=="default"){

		// 									postsData[_index].vote 			= formVotePost.vote;
		// 									postsData[_index].vote_total 	= flash.data['vote_total'];
		// 									postsData[_index].vote_weight 	= flash.data['vote_weight'];

		// 									formVotePost.reset();
		// 								}
		// 							}
		// 						})

		// }


		return{
			is_lazy_loading,
			is_reloading,
			contentSlot,
			formReloadPage,
			formVotePost,
			formJoinCommunity,
			reloadPage,
			postsData,
			lazyLoad,
			joinCommunity,
			votePost,
		}

	},
}
</script>
